module.exports = __webpack_public_path__ + "static/media/no_ads_feb_2022_thumb.a3a8e588.jpg";